export function updateListState(id, data, list, id_key = "id", add_as_last = false, only_if_found = false) {
    const listIndex = list.findIndex(t => t[id_key] === id);
    if (data) {
        if (listIndex > -1) {
            list.splice(listIndex, 1, Object.assign(list[listIndex], data));
        } else {
            if (add_as_last) {
                list.push(data);
            } else {
                list.unshift(data);
            }
        }
    } else if (listIndex > -1) {
        if (!only_if_found) {
            list.splice(listIndex, 1);
        }
    }
}
export function listStateMerge(state_list, new_list, key, value, order_by = false) {
    const old_list_without_updated_items = state_list.filter(item => item[key] !== value);
    if (!new_list) new_list = [];
    let merged_list = [...old_list_without_updated_items, ...new_list];
    if (order_by) {
        merged_list = merged_list.sort((a, b) => (a[order_by] > b[order_by] ? 1 : -1));
    }
    return merged_list;
}

export function mergeGroups(groups) {
    const merge_map = new Map();
    groups.forEach(group => {
        const previous = merge_map.get(group.name);
        const group_id_list = [];
        if (previous) {
            group_id_list.push(...previous.id);
        }
        group_id_list.push(group.id);
        group.id = group_id_list
        merge_map.set(group.name+group.id, group);
    });
    return Array.from(merge_map.values());
}